<template>
    <div>
        <InitiativesTable :initiatives="initiatives" :empty-text="$t('isEmptyAlert')" />
    </div>
</template>

<script>
import InitiativesTable from '../initiatives/table'

export default {
    name: 'Initiatives',
    components: {
        InitiativesTable,
    },
    props: {
        initiatives: {
            type: Array,
            required: true,
        },
    },
    computed: {
        isToShowEmptyListAlert() {
            return this.initiatives.length === 0
        },
    },
    i18n: {
        messages: {
            'en-US': {
                isEmptyAlert: "You don't have any initiatives yet.",
            },
            'es-ES': {
                isEmptyAlert: 'Todavía no tienes ninguna iniciativa.',
            },
            'pt-BR': {
                isEmptyAlert: 'Você ainda não possui iniciativas.',
            },
        },
    },
}
</script>
